export default __webpack_public_path__ + "static/media/p3.860cf7a1.png";